import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import App from './App';
import { awsConf, awsLibraryConf } from './aws-exports';
import './index.css';
import { initRum } from './rum';

initRum();

Amplify.configure(awsConf, awsLibraryConf);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <RecoilRoot>
    <App />
  </RecoilRoot>,
  // </React.StrictMode>
);
